import initShow from '~/pages/projects/merge_requests/init_merge_request_show';
import initSidebarBundle from 'ee/sidebar/sidebar_bundle';

document.addEventListener('DOMContentLoaded', () => {
  initShow();
  initSidebarBundle();
});



// WEBPACK FOOTER //
// /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/pages/projects/merge_requests/show/index.js